import React from 'react'

const Close = props => (
  <svg width='1em' height='1em' viewBox='-1 -1 19 19' {...props}>
    <path d='M14.864.722L8.5 7.086 2.136.722c-.424-.424-.99-.424-1.414 0-.424.424-.424.99 0 1.414L7.086 8.5.722 14.864c-.424.424-.424.99 0 1.414.424.424.99.424 1.414 0L8.5 9.914l6.364 6.364c.424.424.99.424 1.414 0 .424-.424.424-.99 0-1.414L9.914 8.5l6.364-6.364c.424-.424.424-.99 0-1.414-.424-.424-.99-.424-1.414 0z' />
  </svg>
)

export default Close
